/**
 * @generated SignedSource<<767e278b7e32690b4a864758112b855a>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type EmployeeScheduleEditScheduleTypesScreenQuery$variables = Record<PropertyKey, never>;
export type EmployeeScheduleEditScheduleTypesScreenQuery$data = {
  readonly store: {
    readonly " $fragmentSpreads": FragmentRefs<"EmployeeScheduleEditScheduleList_store">;
  };
};
export type EmployeeScheduleEditScheduleTypesScreenQuery = {
  response: EmployeeScheduleEditScheduleTypesScreenQuery$data;
  variables: EmployeeScheduleEditScheduleTypesScreenQuery$variables;
};

const node: ConcreteRequest = (function(){
var v0 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "id",
  "storageKey": null
},
v1 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "name",
  "storageKey": null
},
v2 = [
  (v0/*: any*/),
  (v1/*: any*/),
  {
    "alias": null,
    "args": null,
    "kind": "ScalarField",
    "name": "providerId",
    "storageKey": null
  }
],
v3 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "color",
  "storageKey": null
};
return {
  "fragment": {
    "argumentDefinitions": [],
    "kind": "Fragment",
    "metadata": null,
    "name": "EmployeeScheduleEditScheduleTypesScreenQuery",
    "selections": [
      {
        "alias": null,
        "args": null,
        "concreteType": "Store",
        "kind": "LinkedField",
        "name": "store",
        "plural": false,
        "selections": [
          {
            "args": null,
            "kind": "FragmentSpread",
            "name": "EmployeeScheduleEditScheduleList_store"
          }
        ],
        "storageKey": null
      }
    ],
    "type": "Query",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": [],
    "kind": "Operation",
    "name": "EmployeeScheduleEditScheduleTypesScreenQuery",
    "selections": [
      {
        "alias": null,
        "args": null,
        "concreteType": "Store",
        "kind": "LinkedField",
        "name": "store",
        "plural": false,
        "selections": [
          {
            "alias": null,
            "args": null,
            "concreteType": "IntegrationTilTid",
            "kind": "LinkedField",
            "name": "integrationTilTid",
            "plural": false,
            "selections": [
              {
                "alias": null,
                "args": null,
                "concreteType": "IntegrationTilTidSecondaryScheduleTypeOption",
                "kind": "LinkedField",
                "name": "secondaryScheduleTypeOptions",
                "plural": true,
                "selections": (v2/*: any*/),
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "concreteType": "IntegrationTilTidSecondaryScheduleTypeOption",
                "kind": "LinkedField",
                "name": "secondaryScheduleTypeOption",
                "plural": false,
                "selections": (v2/*: any*/),
                "storageKey": null
              },
              (v0/*: any*/)
            ],
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "concreteType": "Team",
            "kind": "LinkedField",
            "name": "allTeams",
            "plural": true,
            "selections": [
              (v0/*: any*/),
              (v1/*: any*/),
              (v3/*: any*/),
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "icon",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "isPrivate",
                "storageKey": null
              }
            ],
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "concreteType": "EmployeeScheduleType",
            "kind": "LinkedField",
            "name": "employeeScheduleTypes",
            "plural": true,
            "selections": [
              (v0/*: any*/),
              {
                "alias": null,
                "args": null,
                "concreteType": "Team",
                "kind": "LinkedField",
                "name": "assignedTeams",
                "plural": true,
                "selections": [
                  (v0/*: any*/)
                ],
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "title",
                "storageKey": null
              },
              (v3/*: any*/)
            ],
            "storageKey": null
          },
          (v0/*: any*/)
        ],
        "storageKey": null
      }
    ]
  },
  "params": {
    "cacheID": "06c666320250078f84c753575e0cdc2d",
    "id": null,
    "metadata": {},
    "name": "EmployeeScheduleEditScheduleTypesScreenQuery",
    "operationKind": "query",
    "text": "query EmployeeScheduleEditScheduleTypesScreenQuery {\n  store {\n    ...EmployeeScheduleEditScheduleList_store\n    id\n  }\n}\n\nfragment EmployeeScheduleEditScheduleListItemAssignedScheduleType_employeeScheduleType on EmployeeScheduleType {\n  id\n  title\n  color\n}\n\nfragment EmployeeScheduleEditScheduleListItem_scheduleTags on EmployeeScheduleType {\n  id\n  ...EmployeeScheduleEditScheduleListItemAssignedScheduleType_employeeScheduleType\n}\n\nfragment EmployeeScheduleEditScheduleListItem_team on Team {\n  name\n  ...TeamIconCircleComponent_Team\n}\n\nfragment EmployeeScheduleEditScheduleList_store on Store {\n  integrationTilTid {\n    secondaryScheduleTypeOptions {\n      id\n    }\n    secondaryScheduleTypeOption {\n      id\n      name\n    }\n    ...SelectSecondaryScheduleTypeDimension_integrationTilTid\n    id\n  }\n  allTeams {\n    id\n    name\n    ...EmployeeScheduleEditScheduleListItem_team\n  }\n  employeeScheduleTypes {\n    id\n    assignedTeams {\n      id\n    }\n    ...EmployeeScheduleEditScheduleListItemAssignedScheduleType_employeeScheduleType\n    ...EmployeeScheduleEditScheduleListItem_scheduleTags\n  }\n}\n\nfragment SelectSecondaryScheduleTypeDimension_integrationTilTid on IntegrationTilTid {\n  id\n  secondaryScheduleTypeOptions {\n    id\n    name\n    providerId\n  }\n  secondaryScheduleTypeOption {\n    id\n    name\n    providerId\n  }\n}\n\nfragment TeamIconCircleComponent_Team on Team {\n  color\n  icon\n  isPrivate\n}\n"
  }
};
})();

(node as any).hash = "8dfa11d3df14d52ca320ee88995c7e16";

export default node;
